import { useState, useCallback } from "react";
import { showError, showSuccess } from "../utils/toastUtils";

export default function useDeleteItem(deleteApi, onSuccess) {
    
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const openDelete = useCallback((id) => {
    setDeleteId(id);
  }, []);

  const handleDelete = useCallback(async () => {
    if (!deleteId) return;

    try {
      setIsDeleting(true);
      const res = await deleteApi(deleteId);

      if (res.code === 200) {
        showSuccess(res.message);

        onSuccess?.();

        document.querySelector("#delete-modal .btn-close")?.click();
      } else {
        showError(res.message);
      }
    } catch {
      showError("Delete failed");
    } finally {
      setIsDeleting(false);
      setDeleteId(null);
    }
  }, [deleteId, deleteApi]);

  return {
    deleteId,
    isDeleting,
    openDelete,
    handleDelete,
  };
}
